import * as actionList from '../actions/reportmonthlyforecastactions';
import moment from 'moment';

const state = {
    search: '',
    page: 0,
    year: moment().year(),
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    year: state => state.year,

};

const actions = {
    [actionList.REPORTMONTHLYFORECAST_SEARCH]: ({ commit }, search) => {
        commit(actionList.REPORTMONTHLYFORECAST_SEARCH, search);
    },
    [actionList.REPORTMONTHLYFORECAST_PAGE]: ({ commit }, page) => {
        commit(actionList.REPORTMONTHLYFORECAST_PAGE, page);
    },
    [actionList.REPORTMONTHLYFORECAST_YEAR]: ({ commit }, year) => {
        commit(actionList.REPORTMONTHLYFORECAST_YEAR, year);
    },
};

const mutations = {
    [actionList.REPORTMONTHLYFORECAST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionList.REPORTMONTHLYFORECAST_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionList.REPORTMONTHLYFORECAST_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};